import React from 'react';
import classes from './BrowserApp.module.scss';
import { browserName, isChrome, isFirefox, isOpera, isEdge, isDesktop } from 'react-device-detect';

import Button from '../../atoms/Button/Button';
import BrowserAppHelp from '../../organisms/BrowserAppHelp/BrowserAppHelp';
import A from '../../atoms/A/A';
import StoreLinks from '../../atoms/StoreLinks/StoreLinks';
import ExternalLinkIcon from '../../assets/externalLink.svg';
import * as pages from '../pages';
import Notice from 'components/atoms/Notice/Notice';

export interface Props {}

const appVersion = (name: string) => {
  // in the future, additional browser apps may become available. This switch is so we know how the browser apps differ for ease of development
  switch (name) {
    case 'firefox': {
      return '3.0.0';
    }
    default: {
      return '3.0.0';
    }
  }
};

const appExtension = (name: string) => {
  // in the future, additional browser apps may become available. This switch is so we know how the browser apps differ for ease of development
  switch (name) {
    case 'firefox': {
      return '.xpi';
    }
    default: {
      return '.xpi';
    }
  }
};

const BrowserApp: React.FC<Props> = () => {
  function setDownloadLink() {
    if (isChrome || isEdge || isOpera) {
      return 'https://chrome.google.com/webstore/detail/qmee/mbaanpgkpkoamihninlcegnjclcpibde';
    }
    if (isFirefox) {
      return `https://qmee-apps.s3.amazonaws.com/${browserName.toLowerCase()}/qmee_${appVersion(
        browserName.toLowerCase(),
      )}${appExtension(browserName.toLowerCase())}`;
    }
    return '';
  }

  const downloadLink = setDownloadLink();

  if ((isChrome || isFirefox || isOpera || isEdge) && isDesktop) {
    return (
      <div className={classes.root}>
        <h2 className={classes.title}>Qmee Browser Extension</h2>
        <div className={classes.introduction}>
          <div className={classes.introductionText}>
            <p>Qmee rewards you for the searches you do everyday.</p>
            <p>
              Extra results with cash rewards appear when you search, because you deserve a little
              back for your attention and interest. Add them up and you could be paying for the
              things you like to do online.
            </p>
            <p>
              The Qmee app only operates when you have signed up to the Qmee service and agreed to
              the terms and conditions. If you do not wish to sign up the app will not operate or
              send any data.
            </p>
            <p>As part of its normal operation the app sends some personal user data.</p>
            <p>
              The app sends us your search terms and product views across major search engines,
              major retail sites and other sites with search functionality so that we can display
              additional relevant search results. If you click on a Qmee result the app will send
              browsing activity, limited to web page address, on only the target site and for a
              limited time so that we can ensure that we reward users who have a real interest in
              the search result.
              <br />
              All communication between the Qmee app and our servers is encrypted. We do not track
              any other browsing activity.
            </p>
          </div>
          <div className={classes.buttonContainer}>
            <A to={downloadLink} className={classes.externalLink}>
              <Button buttonSize="large" buttonType="primary" color="secondary">
                <ExternalLinkIcon className={classes.icon} />
                Get the Browser App
              </Button>
            </A>
          </div>
        </div>
        <Notice className={classes.disclaimers}>
          <p>
            Information about how we collect and process your data is available in our{' '}
            <A to={pages.PRIVACY_NOTICE.path}>Privacy Notice</A> and{' '}
            <A to={pages.PRIVACY_PROMISE.path}>Privacy Promise</A>.
          </p>
        </Notice>
        <BrowserAppHelp />
      </div>
    );
  }
  if (isDesktop) {
    return (
      <div className={classes.root}>
        The browser app is currently only available on Chrome, Edge, Firefox and Opera.
      </div>
    );
  }
  return (
    <div className={classes.root}>
      <p>The browser app is only available on desktop, but did you know we have a mobile app?</p>
      <StoreLinks />
    </div>
  );
};

export default BrowserApp;
